import { Injectable } from '@angular/core';
import { MobileUser, MobileUserMembershipStatus } from '../../domain/models/mobile-user.model';
import { MobileUserCreateInput } from '../../domain/models/mobile-user-create-input.model';
import { MobileUserUpdateInput } from '../../domain/models/mobile-user-update-input.model';
import { LocalClientDto } from '../dtos/local-client.dto';
import { CreateMobileClientPayload, UpdateMobileClientPayload } from '../datasources/remote/mobile-users.remote-datasource';

const MEMBERSHIP_STATUSES: readonly MobileUserMembershipStatus[] = ['pending', 'active', 'revoked'];

function toMembershipStatus(value: string | null | undefined): MobileUserMembershipStatus | null {
  return MEMBERSHIP_STATUSES.find((status) => status === value) ?? null;
}

@Injectable()
export class MobileUserMapper {
  public toMobileUser(dto: LocalClientDto): MobileUser | null {
    if (dto.AccountRealm !== 'pet_owner') return null;

    return {
      id: dto.ClientId,
      publicId: dto.PublicId,
      username: dto.Username,
      avatarUrl: dto.AvatarUrl,
      firstName: dto.FirstName ?? '',
      lastName: dto.LastName ?? '',
      roleId: dto.RoleId,
      departmentIds: dto.DepartmentIds ?? [],
      isActive: dto.IsActive,
      createdAt: dto.CreatedAt,
      homeOrganizationId: dto.OrganizationId,
      linkedProviderClientExternalId: dto.ExternalClientId,
      invitationPending: dto.InvitationPending,
      invitationDeliveryFailed: dto.InvitationDeliveryFailed,
      membershipStatus: toMembershipStatus(dto.MembershipStatus),
      membershipBannedAtUtc: dto.MembershipBannedAtUtc ?? null,
      isBannedHere: (dto.MembershipBannedAtUtc ?? null) !== null,
    };
  }

  public toCreatePayload(input: MobileUserCreateInput): CreateMobileClientPayload {
    return {
      Username: input.username,
      FirstName: input.firstName,
      LastName: input.lastName,
      RoleId: null,
      DepartmentIds: input.departmentIds,
      LinkedProviderClientExternalId: input.linkedClientExternalId,
      CreateInProvider: false,
      LinkExistingAccount: input.linkedClientExternalId !== '',
    };
  }

  public toUpdatePayload(input: MobileUserUpdateInput): UpdateMobileClientPayload {
    return {
      Username: input.username,
      FirstName: input.firstName,
      LastName: input.lastName,
      RoleId: input.roleId,
      DepartmentIds: input.departmentIds,
      IsActive: input.isActive,
      LinkedProviderClientExternalId: input.linkedProviderClientExternalId,
    };
  }
}
